import type { ComboBoxOption } from './ComboBoxOption';

export enum ComboBoxChangeAction {
    Clear = 'clear',
    Deselect = 'deselect',
    Remove = 'remove',
    Select = 'select',
}

export interface ComboBoxChangeMeta<Option extends ComboBoxOption> {
    action: ComboBoxChangeAction;
    option: Option | null;
    options: Option[];
}
